import React, { useState, useEffect, useRef } from 'react';
import Footer from '../components/Footer';
import Navbar from '../components/navbar/Navbar.js';
import Banner from '../components/Banner.js';
import Modal from '../components/Modal.js';
import banner from '../images/stromspeicher/banner.png';
import v50 from '../images/stromspeicher/v50.mp4';
import v51 from '../images/stromspeicher/v51.mp4';
import cutted from '../images/stromspeicher/cutted.mp4';
import pic1 from '../images/stromspeicher/pic1.png';
import pic3 from '../images/stromspeicher/pic3.avif';
import pdfpic1 from '../images/stromspeicher/pdfpic1.jpg';
import { useSEO } from '../components/CustomHook';

const StorageSystems = () => {
    useSEO(
        "Stromspeicher - EcoFlow Power Ocean & Energiespeicher | Schmid Energieberatung",
        "Entdecken Sie unsere innovativen Speichersysteme wie das EcoFlow Power Ocean. 5-in-1-Technologie für intelligente Energiespeicherung und -verwaltung.",
        "Speichersysteme, Energiespeicher, EcoFlow Power Ocean, Batteriespeicher, Solar Speicher, Stromspeicher",
    );

    // State für die Modals
    const [modalData, setModalData] = useState({ isOpen: false, title: '', content: [] });

    // State für den Zähler
    const [count, setCount] = useState(0);
    const counterRef = useRef(null);
    const [hasCounted, setHasCounted] = useState(false);

    // Funktion zum Schließen des Modals
    const closeModal = () => {
        setModalData({ isOpen: false, title: '', content: [] });
    };

    // Funktion zum Öffnen des Modals für Box 1 (Sicherheitssystem)
    const openModalBox1 = () => {
        setModalData({
            isOpen: true,
            title: "Sichere Batterietechnologie – zuverlässig, langlebig, schadstofffrei",
            content: [
                <>
                <strong>Prismatische LiFePO₄-Zellen</strong> setzen neue Maßstäbe in puncto Sicherheit und Effizienz. Sie
                gehören zu den fortschrittlichsten Speicherlösungen auf dem Markt – und das aus gutem
                Grund:
                </>,
                <>
                <ul className="list-disc list-inside mt-2 space-y-1">
                    <li><strong>Maximale Sicherheit</strong> – dank hoher thermischer und chemischer Stabilität</li>
                    <li><strong>Lange Lebensdauer</strong> – bis zu 10.000 Ladezyklen für jahrzehntelangen Einsatz</li>
                    <li><strong>Umweltfreundlich & ungiftig</strong> – keine Schwermetalle, keine explosiven Stoffe</li>
                    <li><strong>Wartungsfrei & stabil im Betrieb</strong> – selbst bei extremen Temperaturen</li>
                </ul>
                </>,
                <>
                Im Vergleich zu herkömmlichen Lithium-Ionen-Batterien sind LiFePO₄-Zellen deutlich
                robuster, weniger hitzeanfällig und absolut alltagstauglich – ideal für Hausbesitzer, die auf
                <strong>sichere, nachhaltige und zukunftsfähige Energiespeicherung</strong> setzen.
                </>,
            ]
        });
    };

    // Funktion zum Öffnen des Modals für Box 2 (Batterietechnologie)
    const openModalBox2 = () => {
        setModalData({
            isOpen: true,
            title: "Schutz vor Kurzschluss und Lichtbogen – in Echtzeit",
            content: [
                <>
                Modernste Sensorik überwacht permanent den Stromfluss und erkennt <strong>Lichtbögen, Funken
                oder Kurzschlüsse</strong> innerhalb von Millisekunden. Im Ernstfall reagiert das System sofort und
                schaltet automatisch ab – <strong>bevor es zu Schäden kommt</strong>.
                </>,
                <>
                Diese intelligente Sicherheitsfunktion schützt nicht nur Ihre Anlage vor Überlastung oder
                Fehlfunktionen, sondern trägt auch maßgeblich zur <strong>Lebensdauerverlängerung und
                Betriebssicherheit</strong> Ihres gesamten Energiesystems bei.
                </>,
                <>
                <strong>Mehr Sicherheit – vollautomatisch und unsichtbar im Hintergrund.</strong>
                </>,
            ]
        });
    };

    // Funktion zum Öffnen des Modals für Box 3 (Wasserstrahlen)
    const openModalBox3 = () => {
        setModalData({
            isOpen: true,
            title: "Robust, wetterfest und kälteresistent – der SigenStore",
            content: [
                <>
                Mit seinem <strong>IP66-zertifizierten Aluminiumgehäuse</strong>  ist der <strong>SigenStore</strong> optimal gegen Staub
                und starke Wasserstrahlen geschützt – und damit ideal für die <strong>Installation im geschützten
                Außenbereich</strong>, etwa an Hauswänden oder Carports.
                </>,
                <>
                Ein besonderes Highlight:
                </>,
                <>
                Dank <strong>integrierter Batterieheizung</strong> ist der Speicher auch bei <strong>Außentemperaturen bis –
                20 °C voll einsatzbereit</strong>. Die Zellen werden bei Kälte automatisch vorgewärmt, sodass
                <strong>Leistung, Sicherheit und Lebensdauer auch im Winter garantiert bleiben</strong>.
                </>,
                <>
                Ob bei Hitze, Regen oder Frost – der SigenStore ist auf alle Bedingungen vorbereitet und
                bietet Ihnen maximale Zuverlässigkeit, wo immer Sie ihn brauchen.
                </>,
            ]
        });
    };

    const openModalBox4 = () => {
        setModalData({
            isOpen: true,
            title: "SigenStore – Intelligente Speicherarchitektur für maximale Effizienz und Lebensdauer",
            content: [
                <>
                Der <strong>SigenStore</strong> kombiniert eine <strong>patentierte DC-gekoppelte Architektur</strong> mit einem
                intelligenten <strong>Batteriemanagementsystem (BMS)</strong> – für höchste Effizienz, Sicherheit und
                Zukunftsfähigkeit.
                </>,
                <>
                PV-Anlage, Speicher und Wallbox sind über einen gemeinsamen <strong>DC-Bus</strong> direkt verbunden.
                Das reduziert Energieverluste und steigert die Systemleistung deutlich. Das integrierte BMS
                überwacht alle Batteriemodule in Echtzeit, steuert präzise Lade- und Entladevorgänge und
                schützt vor Überlastung oder Zellschäden.
                </>,
                <>
                Ein besonderes Highlight: <strong>Neue und gebrauchte Batterien lassen sich problemlos
                kombinieren</strong> – jede Einheit wird individuell optimiert, was <strong>flexible Erweiterungen</strong> und
                <strong>wirtschaftliche Nachrüstungen</strong> ermöglicht.
                </>,
                <>
                Mit <strong>Premium-314 Ah-Zellen</strong>, bis zu <strong>10.000 Zyklen, 100 % nutzbarer Entladetiefe</strong> und
                einem <strong>5-fach Schutzsystem</strong> ist der SigenStore die ideale Lösung für alle, die <strong>effizient, sicher
                und langfristig unabhängig</strong> speichern möchten.
                </>,
            ]
        });
    };

    // Funktion zum Öffnen des Modals für Box 5 (10000 Ladezyklen)
    const openModalBox5 = () => {
        setModalData({
            isOpen: true,
            title: "10.000 Ladezyklen – langlebig und zuverlässig",
            content: [
                <>
                Der <strong>SigenStore</strong> setzt auf langlebige <strong>LiFePO₄-Zellen</strong> mit bis zu <strong>10.000 Ladezyklen</strong> – für eine
                jahrelang zuverlässige und sichere Stromversorgung.
                </>,
                <>
                Das integrierte <strong>Batteriemanagementsystem</strong> schützt die Zellen vor Überladung,
                Tiefentladung und ungleichmäßiger Belastung. So bleibt die Leistung konstant hoch – und
                Ihre Investition dauerhaft wertbeständig.
                </>,
            ]
        });
    };

    // Funktion zum Öffnen des Modals für Box 6 (EV Charging Module)
    const openModalBox6 = () => {
        setModalData({
            isOpen: true,
            title: "Sigen EV DC – Die nächste Stufe der Heimenergieintegration",
            content: [
                <>
                Mit dem <strong>Sigen EV DC Charging Module</strong> beginnt eine neue Ära der Energieunabhängigkeit.
                Als <strong>weltweit erstes All-in-One-Heimenergiesystem mit integrierter V2X-Technologie</strong>
                verbindet es Elektromobilität und Energiespeicherung auf völlig neue Weise – <strong>bidirektional,
                effizient und nachhaltig</strong>.
                </>,
                <>
                Mit bis zu <strong>25 kW Lade- und Entladeleistung</strong>, einer variablen <strong>Ladespannung von 150–
                1000 V</strong> und <strong>universeller EV-Kompatibilität</strong> ermöglicht Sigen EV DC nicht nur das
                ultraschnelle Laden Ihres Fahrzeugs, sondern auch die <strong>Rückeinspeisung von Strom aus der
                Fahrzeugbatterie ins Hausnetz (V2H)</strong> – oder sogar ins öffentliche Netz (V2G). Damit wird
                Ihr Elektrofahrzeug zur mobilen Energieressource.
                </>,
                <>
                Ob zur <strong>Sicherung der Stromversorgung bei Netzausfall</strong>, zur <strong>Entlastung durch Peak
                Shaving</strong>, oder für den <strong>Einsatz in virtuellen Kraftwerken (VPP)</strong> – dieses Modul eröffnet
                <strong>völlig neue Dimensionen in der Energievernetzung</strong>.
                </>,
                <>
                Dank <strong>IP66-Schutzklasse</strong>, wartungsfreiem Betrieb und vollständiger Integration in das Sigen-
                Energiesystem ist der EV DC Charger nicht nur leistungsstark, sondern auch zuverlässig und
                zukunftssicher.
                </>,
            ]
        });
    };

    // Effekt für den Zähler
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !hasCounted) {
                        setHasCounted(true);
                        let start = 0;
                        const end = 10000;
                        const duration = 2000; // 2 seconds
                        const increment = end / (duration / 16); // 16ms per frame

                        const timer = setInterval(() => {
                            start += increment;
                            if (start >= end) {
                                start = end;
                                clearInterval(timer);
                            }
                            setCount(Math.floor(start));
                        }, 16);
                    }
                });
            },
            { threshold: 0.5 } // Trigger when 50% of the element is visible
        );

        const node = counterRef.current;
        if (node) {
            observer.observe(node);
        }

        return () => {
            if (node) {
                observer.unobserve(node);
            }
        };
    }, [hasCounted]);

    return (
        <>
            <Navbar />
            <Banner
                imageSrc={banner}
                title="Stromspeicher"
                subtitle="Energiespeicherung neu gedacht – mit Sigenergy"
                description="Sigen.Storage steht für die nächste Stufe intelligenter Stromspeicherung:
                    Maximale Leistung, elegantes Design und intelligente Steuerung in einem System.
                    Ob Tag oder Nacht – Ihr Solarstrom steht jederzeit zur Verfügung, automatisch optimiert
                    durch das smarte Energiemanagement von Sigen.Ai.
                    Für mehr Unabhängigkeit, niedrigere Stromkosten und ein Energiesystem, das mitdenkt.
                    Sigenergy – die Speicherlösung für alle, die mehr wollen."
            />

            {/* Grid Section */}
            <div className="w-full max-w-7xl mx-auto py-16 px-8">
                <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 grid-rows-3 gap-8">
                    {/* Box 1: Reihe 1, Spalte 1 */}
                    <div className="bg-secondary-light rounded-xl flex flex-col items-center justify-center p-8 transition-all duration-300 hover:scale-105 hover:shadow-2xl">
                        <h3 className="text-2xl font-bold text-center mb-6">Langlebigkeit durch hohe<br />Zyklen</h3>
                        <p className="text-4xl font-bold text-center text-primary">10.000</p>
                    </div>

                    {/* Box 2: Reihe 1, Spalte 2 */}
                    <div className="bg-primary rounded-xl flex flex-col items-center justify-center p-8 transition-all duration-300 hover:scale-105 hover:shadow-2xl">
                        <h3 className="text-2xl font-bold text-center mb-6 text-white">Bis zu 4 MPPT Tracker</h3>
                        <p className="text-lg text-center text-white">Bis zu 4 unabhängige Dachflächen<br />anbinden</p>
                    </div>

                    {/* Box 3: Reihe 1 & 2, Spalte 3 */}
                    <div className="bg-secondary-light rounded-xl flex flex-col items-center justify-center p-8 transition-all duration-300 hover:scale-105 hover:shadow-2xl md:row-span-2 relative overflow-hidden">
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className="absolute inset-0 w-full h-full object-cover rounded-xl"
                        >
                            <source src={v50} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                        <div className="absolute inset-0 bg-black/30 rounded-xl"></div>
                        <div className="relative z-10 text-white text-center">
                            <p className="text-xl" style={{
                                    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)'
                                }}>
                                Dank hoher Be- und<br />
                                Entladeleistung steht Ihnen<br />
                                Energie im Bruchteil einer<br />
                                Sekunde zur Verfügung – genau<br />
                                dann, wenn sie gebraucht wird.
                            </p>
                        </div>
                    </div>

                    {/* Box 4: Reihe 2, Spalte 1 */}
                    <div className="bg-primary rounded-xl flex flex-col items-center justify-center p-8 transition-all duration-300 hover:scale-105 hover:shadow-2xl">
                        <h3 className="text-2xl font-bold text-center mb-6 text-white">Maximale Sicherheit</h3>
                        <p className="text-lg text-center text-white">
                            durch 5-1 Sicherheitssystem und<br />
                            integriertem Feuerlöscher
                        </p>
                    </div>

                    {/* Box 5: Reihe 2, Spalte 2 */}
                    <div className="bg-secondary-light rounded-xl flex flex-col items-center justify-center p-8 transition-all duration-300 hover:scale-105 hover:shadow-2xl">
                        <h3 className="text-2xl font-bold text-center mb-6">Intelligent vernetzt</h3>
                        <p className="text-lg text-center">Dank Sigen Ai Managementsystem</p>
                    </div>

                    {/* Box 6: Reihe 3, Spalte 1 & 2 & 3 */}
                    <div className="bg-secondary-light rounded-xl flex flex-col items-center justify-center p-8 transition-all duration-300 hover:scale-105 hover:shadow-2xl md:col-span-3 md:row-start-3 relative overflow-hidden">
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className="absolute inset-0 w-full h-full object-cover object-[50%_39%] rounded-xl"
                        >
                            <source src={cutted} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                </div>
            </div>

            {/* Textabschnitte */}
            <div className="w-full max-w-7xl mx-auto py-20 px-6">

                {/* Secondary Navigation */}
                <div className="flex justify-center mb-16">
                    <div className="bg-secondary-light rounded-full px-4 py-2 flex flex-wrap justify-center gap-2 sm:gap-4">
                        <a href="#mehr-energie" className="px-4 py-2 text-sm sm:text-base font-semibold text-tertiary hover:text-primary transition-colors duration-200">
                            Mehr Energie
                        </a>
                        <a href="#mehr-vertrauen" className="px-4 py-2 text-sm sm:text-base font-semibold text-tertiary hover:text-primary transition-colors duration-200">
                            Mehr Vertrauen
                        </a>
                        <a href="#mehr-lebenszeit" className="px-4 py-2 text-sm sm:text-base font-semibold text-tertiary hover:text-primary transition-colors duration-200">
                            Mehr Lebenszeit
                        </a>
                    </div>
                </div>

                {/* Mehr Energie Section */}
                <div id="mehr-energie" className="mb-20 text-center">
                    <h3 className="text-2xl md:text-3xl font-semibold text-primary mb-6">
                        Mehr Energie
                    </h3>
                    <h4 className="text-xl md:text-2xl font-semibold text-gray-800 mb-8">
                        Starke Leistung für maximale Energieverfügbarkeit
                    </h4>
                    <div className="text-lg text-gray-700 leading-relaxed mb-12 max-w-4xl mx-auto">
                        <p className="mb-6">
                            Der Speicher setzt neue Standards in Sachen Geschwindigkeit und Effizienz. Dank modernster
                            Technologie und durchdachter Systemarchitektur bietet er ein Höchstmaß an Leistung und
                            Flexibilität – und bringt Ihre Energieversorgung auf das nächste Level.
                        </p>
                    </div>

                    {/* Drei Boxen unterhalb der Textabschnitte */}
                    <div className="w-full max-w-7xl mx-auto py-16 px-8">
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                            {/* Box 1 */}
                            <div
                                className="bg-primary rounded-2xl shadow-xl   p-8 transition-all duration-300 hover:scale-105 hover:shadow-2xl cursor-pointer"
                                onClick={openModalBox1}
                            >
                                <h3 className="text-2xl font-bold text-center mb-4 text-white">Bis 4 MPPT Dachseiten</h3>
                                <p className="text-center text-white mb-6">anbinden oder zusätzlich den Sigen Microinverter nutzen</p>
                                <div className="text-center">
                                    <button
                                        className="text-white font-semibold hover:underline"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            openModalBox1();
                                        }}
                                    >
                                        mehr erfahren
                                    </button>
                                </div>
                            </div>

                            {/* Box 2 */}
                            <div
                                className="bg-secondary rounded-2xl shadow-xl  p-8 transition-all duration-300 hover:scale-105 hover:shadow-2xl cursor-pointer"
                                onClick={openModalBox2}
                            >
                                <h3 className="text-2xl font-bold text-center mb-4 text-gray-900">In Sekunden voll einsatzbereit.</h3>
                                <p className="text-center text-gray-600 mb-6">Schnell laden. Stark entladen.</p>
                                <div className="text-center">
                                    <button
                                        className="text-primary font-semibold hover:underline"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            openModalBox2();
                                        }}
                                    >
                                        mehr erfahren
                                    </button>
                                </div>
                            </div>

                            {/* Box 3 */}
                            <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8 transition-all duration-300 hover:scale-105 hover:shadow-2xl relative overflow-hidden flex flex-col items-center justify-center">
                                <img
                                    src={pic1}
                                    alt="Perfekt vernetzt"
                                    className="absolute inset-0 w-full h-full object-contain"
                                />
                                <div className="relative z-10 text-center">
                                    <h3 className="text-2xl font-bold mb-4 text-gray-900 bg-white/80 px-4 py-2 rounded-lg inline-block">Perfekt vernetzt</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Mehr Vertrauen Section */}
                <div id="mehr-vertrauen" className="mb-20 text-center">
                    <h3 className="text-2xl md:text-3xl font-semibold text-primary mb-6">
                        Mehr Vertrauen
                    </h3>
                    <h4 className="text-xl md:text-2xl font-semibold text-gray-800 mb-8">
                        Sicherheit, auf die Sie sich verlassen können
                    </h4>
                    <div className="text-lg text-gray-700 leading-relaxed mb-12 max-w-4xl mx-auto">
                        <p className="mb-6">
                            Beim Thema Energiespeicherung hat Sicherheit oberste Priorität – und der SigenStor erfüllt
                            genau das. Durch intelligente Schutzmechanismen und automatische Gefahrenüberwachung
                            ist Ihr System rundum abgesichert – vor Überlastung, Überhitzung oder äußeren Einflüssen.
                        </p>
                    </div>

                    {/* Two boxes side by side */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
                        {/* Box 1: 5 in 1 Sicherheitssystem */}
                        <div
                            className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8 transition-all duration-300 hover:scale-105 hover:shadow-2xl cursor-pointer"
                            onClick={openModalBox1}
                        >
                            <h3 className="text-2xl font-bold text-gray-900 mb-4">5 in 1 Sicherheitssystem mit Lichtbogenerkennung</h3>
                            <div className="mt-6">
                                <button
                                    className="text-primary font-semibold hover:underline"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        openModalBox1();
                                    }}
                                >
                                    mehr erfahren
                                </button>
                            </div>
                        </div>

                        {/* Box 2: Sichere Batterietechnologie */}
                        <div
                            className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8 transition-all duration-300 hover:scale-105 hover:shadow-2xl cursor-pointer"
                            onClick={openModalBox2}
                        >
                            <h3 className="text-2xl font-bold text-gray-900 mb-4">Sichere Batterietechnologie – zuverlässig, langlebig, schadstofffrei</h3>
                            <div className="mt-6">
                                <button
                                    className="text-primary font-semibold hover:underline"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        openModalBox2();
                                    }}
                                >
                                    mehr erfahren
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* Zwischenüberschrift */}
                    <h3 className="text-2xl md:text-3xl font-semibold text-primary mb-8 text-center mt-16">
                        Alle Vertrauens Features
                    </h3>


                    {/* Two boxes side by side */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
                        {/* Box 1: Geschützt gegen starke Wasserstrahlen */}
                        <div
                            className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8 transition-all duration-300 hover:scale-105 hover:shadow-2xl cursor-pointer"
                            onClick={openModalBox3}
                        >
                            <h3 className="text-2xl font-bold text-gray-900 mb-4">Geschützt gegen starke<br />Wasserstrahlen</h3>
                            <div className="mt-6">
                                <button
                                    className="text-primary font-semibold hover:underline"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        openModalBox3();
                                    }}
                                >
                                    mehr erfahren
                                </button>
                            </div>
                        </div>

                        {/* Box 2: Inselfähig bei Netzausfall */}
                        <div
                            className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8 transition-all duration-300 hover:scale-105 hover:shadow-2xl cursor-pointer"
                        >
                            <h3 className="text-2xl font-bold text-gray-900 mb-4">Inselfähig bei<br />Netzausfall</h3>
                            <div className="mt-6">
                                <button
                                    className="text-primary font-semibold hover:underline"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        // Redirect to Notstrom product page
                                        window.location.href = '/notstrom';
                                    }}
                                >
                                    mehr erfahren
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Mehr Lebenszeit Section */}
                <div id="mehr-lebenszeit" className="mb-20 text-center">
                    <h3 className="text-2xl md:text-3xl font-semibold text-primary mb-6">
                        Mehr Lebenszeit
                    </h3>
                    <h4 className="text-xl md:text-2xl font-semibold text-gray-800 mb-8">
                        Langlebigkeit, die Maßstäbe setzt
                    </h4>
                    <p className="text-lg text-gray-700 leading-relaxed mb-12 max-w-4xl mx-auto">
                        Ein Stromspeicher ist dann wirklich nachhaltig, wenn er nicht nur heute, sondern auch in
                        vielen Jahren zuverlässig arbeitet. Der <strong>SigenStore</strong> wurde genau dafür entwickelt: für
                       <strong>maximale Lebensdauer und gleichbleibende Performance über Jahrzehnte</strong>.
                    </p>
                    <p className="text-lg text-gray-700 leading-relaxed mb-12 max-w-4xl mx-auto">
                        Hochwertige Komponenten, intelligente Zellsteuerung und robuste Bauweise sorgen dafür,
                        dass Sie langfristig profitieren – <strong>technisch wie wirtschaftlich</strong>. Eine Investition, die sich
                        rechnet – Tag für Tag, Jahr für Jahr.
                    </p>

                    {/* Large tile with video background */}
                    <div className="rounded-2xl overflow-hidden shadow-xl mb-16 relative h-64 md:h-80">
                        <video
                            autoPlay
                            loop
                            muted
                            playsInline
                            className="absolute inset-0 w-full h-full object-cover object-[50%_30%]"
                        >
                            <source src={v51} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                        <div className="absolute inset-0 bg-black/30"></div>
                        <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
                            <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">Maximale Lebensdauer</h3>
                            <p className="text-xl md:text-2xl text-white mb-6">Integriertes Batteriemanagementsystem</p>
                            <button
                                className="text-primary font-semibold hover:underline bg-white px-6 py-3 rounded-lg"
                                onClick={(e) => {
                                        e.stopPropagation();
                                        openModalBox4();
                                    }}
                            >
                                mehr erfahren
                            </button>
                        </div>
                    </div>

                    {/* Two boxes side by side */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto mb-16">
                        {/* Box 1: 10000 Ladezyklen mit Zähler */}
                        <div
                            ref={counterRef}
                            className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8 transition-all duration-300 hover:scale-105 hover:shadow-2xl cursor-pointer relative overflow-hidden"
                            onClick={openModalBox5}
                        >
                            <img
                                src={pic3}
                                alt="10000 Ladezyklen"
                                className="absolute inset-0 w-full h-full object-cover object-[10%_35%]"
                            />
                            <div className="relative z-10">
                                <p className="text-5xl font-bold text-primary mb-6">{count.toLocaleString()}</p>
                                <p className="text-2xl font-bold mb-6">Ladezyklen</p>
                                <div className="mt-6">
                                    <button
                                        className="text-primary font-semibold hover:underline"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            openModalBox5();
                                        }}
                                    >
                                        mehr erfahren
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Box 2: Sigen EV DC Charging Module */}
                        <div
                            className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8 transition-all duration-300 hover:scale-105 hover:shadow-2xl cursor-pointer"
                            onClick={openModalBox6}
                        >
                            <h3 className="text-2xl font-bold text-gray-900 mb-4">Sigen EV DC Charging Module</h3>
                            <p className="text-gray-700 mb-6">
                                Fahren, speichern, versorgen – mit Sonnenstrom.<br />
                                Sigen EV DC – Ihr Fahrzeug wird Teil Ihres<br />
                                Energiesystems.
                            </p>
                            <div className="mt-6">
                                <button
                                    className="text-primary font-semibold hover:underline"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        openModalBox6();
                                    }}
                                >
                                    mehr erfahren
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-gray-800 py-12">
                <div className="container mx-auto px-4 text-center">
                    <h2 className="text-2xl font-bold text-white mb-8">Produktinformationen & Downloads</h2>
                    <div className="flex flex-col md:flex-row justify-center gap-6">
                        {/* First PDF Download */}
                        <div className="flex flex-col items-center">
                            <img
                                src={pdfpic1}
                                alt="Sigenergy Sigenstore"
                                className="mb-4 w-full max-w-xs h-auto"
                                onLoad={() => console.log('pdfPic1 loaded successfully')}
                                onError={(e) => {
                                    console.log('Error loading pdfPic1:', e);
                                    e.target.src = '/images/wallbox/pdfpic1.png'
                                }}
                            />
                            <a
                                href="/pdf/stromspeicher/Datenblatt.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-primary text-white rounded-lg font-semibold text-base px-8 py-4 transition-all duration-200 hover:scale-105 inline-block"
                            >
                                Produktinformation Sigenergy Sigenstore
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Additional Text Section */}
            <div className="w-full max-w-7xl mx-auto py-16 px-8">
                <div className="bg-white rounded-xl shadow-lg p-8 md:p-12">
                    <h2 className="text-2xl md:text-3xl font-bold text-center mb-6 text-primary">
                        Unser Energiekonzept – alles aus einer Hand
                    </h2>
                    <div className="text-lg text-gray-700 leading-relaxed">
                        <p className="mb-4">
                            Von der <strong>individuellen Beratung</strong> bis zur <strong>fertig installierten Solaranlage mit Speicher</strong>: Mit
                            dem Energiekonzept der <strong>Schmid Energieberatung GmbH</strong> kümmern wir uns um alles – Sie
                            lehnen sich einfach zurück.
                        </p>
                        <p className="mb-4">
                            Wir begleiten Sie von Anfang an:
                        </p>
                        <ul className="list-none mb-4">
                            <li className="mb-2">✔ Persönliche Beratung bei Ihnen vor Ort</li>
                            <li className="mb-2">✔ Detaillierte Planung nach Ihren Wünschen</li>
                            <li className="mb-2">✔ Auswahl hochwertiger Komponenten</li>
                            <li className="mb-2">✔ Fachgerechte Installation durch zertifizierte Meisterbetriebe</li>
                            <li className="mb-2">✔ Abnahme durch Elektriker und Anmeldung beim Netzbetreiber</li>
                        </ul>
                        <p className="mb-4">
                            Auch nach der Inbetriebnahme sind wir für Sie da:
                        </p>
                        <ul className="list-none mb-4">
                            <li className="mb-2">✔ Einrichtung des Energiemanagement-Systems</li>
                            <li className="mb-2">✔ Wartung, Monitoring und schnelle Hilfe bei Störungen</li>
                            <li className="mb-2">✔ Optional: Reinigungsservice, Garantieabwicklung, Reparaturmanagement</li>
                        </ul>
                        <h3 className="text-xl font-bold mt-8 mb-4 text-primary">
                            Kostenlose PV-Beratung
                        </h3>
                        <p className="mb-4 font-bold">
                            Ihr Weg zur eigenen Solaranlage beginnt hier
                        </p>
                        <p className="mb-4">
                            Lassen Sie sich <strong>kostenlos und unverbindlich</strong> von unseren Experten beraten – persönlich,
                            ehrlich und auf Ihre Situation abgestimmt.
                        </p>
                        <ul className="list-none mb-4">
                            <li className="mb-2">• <strong>Individuelle Einschätzung</strong> Ihrer Dachfläche & Energiebedarfs</li>
                            <li className="mb-2">• <strong>Rückruf durch einen Fachberater</strong> – direkt aus unserer Region</li>
                            <li className="mb-2">• <strong>Transparente Informationen</strong> zu Technik, Wirtschaftlichkeit & Förderung</li>
                        </ul>
                        <p className="text-center font-bold mt-8">
                            Schmid Energieberatung GmbH – Ihre Energielösung aus Meisterhand
                        </p>
                        <div className="flex justify-center mt-8">
                            <a
                                href="/contact"
                                className="bg-primary text-white rounded-lg font-semibold text-base px-8 py-4 lg:px-10 lg:py-5 transition-all duration-200 hover:scale-105"
                            >
                                Beratung vereinbaren
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add Modal component */}
            <Modal
                isOpen={modalData.isOpen}
                onClose={closeModal}
                title={modalData.title}
                content={modalData.content}
            />

            <Footer />
        </>
    );
};

export default StorageSystems;